import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer id="contact" className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img 
                src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/3143f84cced38ce3ece6675b932547d0.png" 
                alt="IQCERT Logo" 
                className="h-10 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">{t('nav.home')}</a></li>
              <li><a href="#about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">{t('nav.about')}</a></li>
              <li><a href="#services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">{t('nav.services')}</a></li>
              <li><a href="#blog" className="text-gray-300 hover:text-white transition-colors cursor-pointer">{t('nav.blog')}</a></li>
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.programs')}</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">{t('services.it.title')}</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">{t('services.business.title')}</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">{t('services.design.title')}</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">{t('services.language.title')}</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.contact')}</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-red-400" />
                <span className="text-gray-300">+90 216 508 24 24</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-red-400" />
                <span className="text-gray-300">info@iqcert.com.tr</span>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-red-400 mt-1" />
                <span className="text-gray-300">
                  Maslak Mahallesi, Büyükdere Caddesi<br />
                  No: 123, Şişli/İstanbul
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 IQCERT. {t('footer.rights')}
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
